import { call, put, takeLatest } from "redux-saga/effects";
import {
GET_BEHAVIORALATTRIBUTES,
ADD_BEHAVIORALATTRIBUTES,
UPDATE_BEHAVIORALATTRIBUTES,
DELETE_BEHAVIORALATTRIBUTES,
GET_BEHAVIORALATTRIBUTES_SUCCESS,
ADD_BEHAVIORALATTRIBUTES_SUCCESS,
UPDATE_BEHAVIORALATTRIBUTES_SUCCESS,
DELETE_BEHAVIORALATTRIBUTES_SUCCESS
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getBehavioralAttributeApi()  {
    // api for get attribute list
   const response = api.dbBehavioralAttribute().GetAttributeList();
    return response;
  }
  function addBehavioralAttributeApi(formData) {
    // api for add  attribute.
   const response= api.dbBehavioralAttribute().AddEditAttribute(formData);
   return response;
  }
  function updateBehavioralAttributeApi(formData) {
    // api for update  attribute.
    api.dbBehavioralAttribute().AddEditAttribute(formData);
  }
  function deleteBehavioralAttributeApi(delId) {
    // api for delete  attribute.
    const response = api.dbBehavioralAttribute().DeleteAttribute(delId);
    return response;
  }
  
export function* handleGetBehavioralAttribute() {
    try {
      const response = yield call(getBehavioralAttributeApi);
      yield put({ type: GET_BEHAVIORALATTRIBUTES_SUCCESS, payload: response.data });
    } catch (error) {
    
    }
  }
  export function* handleAddBehavioralAttribute({ payload }) {
    try {
     const response= yield call(addBehavioralAttributeApi, payload);
     payload={...payload,"attributeId":response.data}
      yield put({ type: ADD_BEHAVIORALATTRIBUTES_SUCCESS, payload: payload });
    } catch (error) {
   
    }
  }
  export function* handleUpdateBehavioralAttribute({ payload }) {
    try {
      let formData = payload;
      yield call(updateBehavioralAttributeApi, formData);
      yield put({ type: UPDATE_BEHAVIORALATTRIBUTES_SUCCESS, payload: formData });
    } catch (error) {
   
    }
  }
  export function* handleDeleteBehavioralAttribute({ payload }) {
    try {
      yield call(deleteBehavioralAttributeApi, payload);
      yield put({ type: DELETE_BEHAVIORALATTRIBUTES_SUCCESS, payload: payload });
    } catch (error) {
  
    }
  }
  
  // watach function.
  export function* BehavioralAttributeWatchFun() {
    yield takeLatest(GET_BEHAVIORALATTRIBUTES, handleGetBehavioralAttribute);
    yield takeLatest(ADD_BEHAVIORALATTRIBUTES, handleAddBehavioralAttribute);
    yield takeLatest(UPDATE_BEHAVIORALATTRIBUTES, handleUpdateBehavioralAttribute);
    yield takeLatest(DELETE_BEHAVIORALATTRIBUTES, handleDeleteBehavioralAttribute);
  }